// extracted by mini-css-extract-plugin
export default {"links":"ContactSection_links__4HSZk","link":"ContactSection_link__MbhGS","icon":"ContactSection_icon__N8xko"};